import React from 'react';
import { useAuth } from '../context/AuthContext';

const UserProfile: React.FC = () => {
  const { user, signOut, isAuthenticated } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  // Only render if user is authenticated
  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="user-profile">
      <span className="user-info">
        Welcome, {user?.username || 'User'}
      </span>
      <button 
        onClick={handleSignOut}
        className="sign-out-button"
        type="button"
      >
        Sign Out
      </button>
    </div>
  );
};

export default UserProfile;